<template>
  <section id="login-layout">
		<img src="@/assets/img/bg_login.jpg" alt="" class="background">
		<div class="content">
			<div class="logo">
				<img src="@/assets/img/ensineme.png" alt="" />
			</div>
			<div>
				<router-view></router-view>
			</div>
		</div>
  </section>
</template>

<script>
export default {
	name: 'LoginLayout'
}
</script>

<style lang="scss">
#login-layout {
	top: 0;
	bottom: 0;
	right: 0;
	left: 0;
	position: fixed;
	width: 100%;
	display: flex;
	justify-content: center;

	.background {
		width: 100%;
		height: 100%;
		position: absolute;
		z-index: -1;
	}

	.content {
		position: absolute;
		display: flex;
		flex-direction: column;
		justify-content: center;
		height: 100%;
		background-image: linear-gradient(to top, rgba(17,56,161, 0.4), rgba(0,131,126, 0.4));
		width: 448px;
		padding: 20px 40px;

		.logo {
			width: 100%;
			text-align: center;

			img {
				margin-bottom: 40px;
				width: 200px;
				position: relative;
				left: -10px;
			}
		}

		form {
			.field {
				display: grid;
				grid-template-columns: 60px auto;
				grid-gap: 0 16px;

				align-items: center;
				background-color: #fff;
				height: 50px;
				padding: 10px;
				border-radius: 5px;

				&:not(:last-of-type) {
					margin-bottom: 5px;
				}

				label {
					color: #06162b;
					font-weight: $font-weight-default-bolder;
				}
				input {
					width: 100%;
					height: 100%;
					border: none;
					outline: none;
					font-size: 1em;
					padding-left: 6px;
				}

				.sub-field {
					display: flex;
					height: 100%;

					.see-password {
						border: none;
						cursor: pointer;
						background: transparent;
						outline: none;

						i {
							transition: 200ms ease;
						}
					}
				}
			}

			.controls {
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				margin-top: 14px;

				button {
					background: #e2e41a;
					width: 100%;
					border: none;
					outline: none;
					font-size: 1.2em;
					font-weight: $font-weight-default-bolder;
					border-radius: 8px;
					padding: 16px 0;
					cursor: pointer;
				}

				a {
					color: #fff;
					margin-top: 10px;
				}
			}
		}
	}
}
</style>
